const E2E_PREFIX = 'tradevan-list';

export default E2E_PREFIX;
